module.exports = __webpack_public_path__ + "static/media/family_24.06a24941.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/family/JPEG/family_24.jpg
// module id = 5854
// module chunks = 0